export const play_store_chart_enum = [
  "FREE",
  "PAID",
  "GROSSING",
];
